import http from '../http-common';

/** Headers so public calendar APIs resolve tenant (localhost / shared link). */
function getPublicTenantHeaders() {
    const headers = {};
    if (typeof window === 'undefined') return headers;
    const qs = new URLSearchParams(window.location.search);
    const tenantId = qs.get('tenantId');
    const tenantSub = qs.get('tenant');
    const stored = localStorage.getItem('publicTenantId');
    const id = tenantId || stored;
    if (id) {
        headers['X-Tenant-ID'] = String(id);
    }
    if (tenantSub) {
        headers['X-Tenant-Subdomain'] = tenantSub;
    }
    return headers;
}

class CalendarService {
    // Get month schedule
    getMonthSchedule(year, month) {
        return http.get(`/calendar/month?year=${year}&month=${month}`);
    }

    // Get day schedule
    getDaySchedule(date) {
        return http.get(`/calendar/day/${date}`);
    }

    // Get month overview
    getMonthOverview(year, month) {
        return http.get(`/calendar/overview?year=${year}&month=${month}`);
    }

    // Get week schedule
    getWeekSchedule() {
        return http.get('/schedule/week');
    }

    // Save default weekday schedule
    saveWeekdaySchedule(data) {
        return http.post('/schedule/weekday', data);
    }

    getCalendarConfig() {
        return http.get('/schedule/config');
    }

    saveCalendarConfig(data) {
        return http.put('/schedule/config', data);
    }

    getOverrides(params = {}) {
        const qs = new URLSearchParams();
        if (params.from) qs.set('from', params.from);
        if (params.to) qs.set('to', params.to);
        const query = qs.toString();
        return http.get(`/schedule/overrides${query ? `?${query}` : ''}`);
    }

    // Override specific date
    overrideSpecificDate(data) {
        return http.post('/schedule/override', data);
    }

    // Delete override
    deleteOverride(date) {
        return http.delete(`/schedule/override/${date}`);
    }

    // Appointment methods
    getAppointments(date) {
        return http.get(`/appointments?date=${date}`);
    }

    createAppointment(data) {
        return http.post('/appointments', data);
    }

    updateAppointment(id, data) {
        return http.put(`/appointments/${id}`, data);
    }

    deleteAppointment(id) {
        return http.delete(`/appointments/${id}`);
    }

    confirmAppointment(id) {
        return http.post(`/appointments/${id}/confirm`);
    }

    cancelAppointment(id) {
        return http.post(`/appointments/${id}/cancel`);
    }

    markAppointmentArrived(id, arrived) {
        return http.post(`/appointments/${id}/arrived`, { arrived });
    }

    getPublicDaySchedule(date, extraHeaders = {}) {
        return http.get(`/public/calendar/day/${date}`, {
            headers: { ...getPublicTenantHeaders(), ...extraHeaders },
        });
    }

    bookPublicAppointment(data, extraHeaders = {}) {
        return http.post('/public/calendar/book', data, {
            headers: { ...getPublicTenantHeaders(), ...extraHeaders },
        });
    }

    getPublicTenantInfo(extraHeaders = {}) {
        return http.get('/public/tenant-info', {
            headers: { ...getPublicTenantHeaders(), ...extraHeaders },
        });
    }
}

export default new CalendarService();
